module.exports = __webpack_public_path__ + "img/5-4.ceb50ab0.svg";